import { makeStyles } from '@material-ui/core'

export const hubjectStyles = makeStyles((theme: any) => {
  return {
    headerWrapper: {
      padding: theme.spacing(1),
      minHeight: 52,
      boxSizing: 'border-box',
    },
    content: {
      height: '91vh',
      overflow: 'auto',
      alignContent: 'flex-start',
    },
    cards: {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'stretch',
      gap: theme.spacing(2),
      paddingLeft: theme.spacing(1),
      paddingTop: theme.spacing(2),
    },
    card: {
      flex: '1 1 380px',
      maxWidth: 560,
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left',
    },
    cardContent: {
      flex: 1,
    },
    description: {
      marginTop: theme.spacing(1),
    },
    resultLabel: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(0.5),
    },
    result: {
      backgroundColor: theme.palette.grey[100],
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(1, 1.5),
      minHeight: 40,
      display: 'flex',
      alignItems: 'center',
      overflowX: 'auto',
      '& .react-json-view': {
        backgroundColor: 'transparent !important',
        fontSize: '0.8rem',
      },
    },
    cardActions: {
      padding: theme.spacing(0, 2, 2, 2),
    },
    dangerButton: {
      color: theme.palette.error.main,
      borderColor: theme.palette.error.main,
    },
  }
})
